import { Outlet } from "react-router-dom";

import { AuthGuard } from "@/components/layout/auth-guard";
import { LOGO_URL } from "@/lib/constants";

export function OnboardingLayout() {
  return (
    <AuthGuard>
      <div className="flex min-h-screen flex-col bg-background">
        <header className="flex h-14 shrink-0 items-center px-4 sm:px-6">
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="" className="h-7 w-auto" />
            <span className="text-[15px] font-semibold">Appio</span>
          </div>
        </header>
        <main className="mx-auto flex w-full max-w-5xl flex-1 flex-col px-4 pt-6 pb-16 sm:px-6">
          <Outlet />
        </main>
      </div>
    </AuthGuard>
  );
}
